(function () {

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire7c47"];
var parcelRegister = parcelRequire.register;
parcelRegister("cJUVO", function(module, exports) {
const $9465d969919b89c1$var$layoutAds = document.querySelectorAll(".layout-ad-container");
$9465d969919b89c1$var$layoutAds.forEach((ad)=>{
    const main = ad.closest("main");
    const singleAd = ad.querySelector(".i-ad-space");
    if (!main || !singleAd) return;
    const isElementOutsideMainBottom = ()=>{
        const adRect = singleAd.getBoundingClientRect();
        const mainRect = main.getBoundingClientRect();
        ad.classList.toggle("--fixed-bottom", adRect.bottom + 40 > mainRect.bottom && !(adRect.bottom > window.innerHeight));
    };
    window.addEventListener("scroll", isElementOutsideMainBottom, true);
});

});

})();
//# sourceMappingURL=layout-ad-container.c61ef1fa.js.map
